export const STRUCTURED_SEARCH_QUERY_CONFIG = {
  SUGGESTION_DEBOUNCE_MS: 200,
  REGISTRY_SUGGESTION_DEBOUNCE_MS: 200,
  QUERY_STALE_MS: 60 * 1000,
  QUERY_RETRY_COUNT: 3,
} as const;
